import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const EppingPage = () => (
  <CostcoLocationTemplate
    warehouseName="Epping"
    suburb="Epping"
    state="Victoria"
    stateShort="VIC"
    address="Epping Rd, Epping VIC 3076"
    path="/costco/epping"
    description="Manage Your Loans is the proud Costco member loan partner for the Epping warehouse in Melbourne's northern corridor. We help Costco Executive Members across Epping, South Morang, Lalor, Mill Park and surrounding suburbs access competitive home loans, car loans and personal loans — with exclusive Costco Shop Card rewards on settlement."
    nearbySuburbs={[
      'Epping',
      'South Morang',
      'Lalor',
      'Mill Park',
      'Thomastown',
      'Wollert',
      'Mernda',
      'Doreen',
      'Bundoora',
      'Reservoir',
    ]}
    localContext={[
      {
        title: 'Northern Melbourne Growth Corridor',
        description:
          'Melbourne\'s north is experiencing rapid residential expansion, particularly in Wollert, Mernda and Doreen. New housing estates and master-planned communities are attracting first home buyers and young families seeking modern homes at competitive prices.',
      },
      {
        title: 'New Developments and Infrastructure',
        description:
          'Major developments across the northern corridor — including new town centres, schools and retail precincts — are boosting property values and creating strong demand for home loans. Suburbs like South Morang and Mill Park offer established amenities alongside new growth.',
      },
      {
        title: 'South Morang Rail Line Access',
        description:
          'The Mernda rail extension has significantly improved connectivity for northern suburbs, making Epping, South Morang and Mernda more accessible to the CBD. This transport infrastructure continues to underpin property demand and lending activity in the area.',
      },
    ]}
    faqs={[
      {
        q: 'How do I claim my Costco Shop Card reward after settling a loan?',
        a:
          'Once your loan settles through Manage Your Loans, we verify your Costco Executive Membership and arrange your Shop Card reward. The process is straightforward — just ensure your membership is active at the time of settlement. Terms and conditions apply.',
      },
      {
        q: 'Can I access the Costco member loan service if I live in South Morang or Mernda?',
        a:
          'Yes. Our Costco member loan partnership serves all suburbs near the Epping warehouse, including South Morang, Mernda, Doreen, Lalor, Mill Park, Thomastown, Wollert, Bundoora, Reservoir and beyond. You don\'t need to live in Epping to access the program.',
      },
      {
        q: 'What types of loans qualify for the Costco Shop Card offer?',
        a:
          'Home loans, car loans, and personal loans settled through Manage Your Loans as a Costco Executive Member may qualify for Shop Card rewards. Each loan type has specific terms — contact us on 0468 007 056 for details.',
      },
      {
        q: 'Are there lending options suited to new estates in Wollert and Doreen?',
        a:
          'Absolutely. We work with lenders experienced in construction loans, house-and-land packages and new estate purchases across Melbourne\'s northern growth corridor. As your Costco member loan partner, we can help you find the right product for a new build or established home.',
      },
    ]}
    suburbData={{
      suburb: 'Epping',
      medianHouse: '$780,000',
      medianUnit: '$450,000',
      daysOnMarket: '28 days',
      rentalYield: '3.4%',
      population: '10,500',
      distanceToCostco: '2 km',
    }}
    surroundingSuburbs={[
      { suburb: 'South Morang', medianHouse: '$750,000', medianUnit: '$440,000', daysOnMarket: '26 days' },
      { suburb: 'Lalor', medianHouse: '$680,000', medianUnit: '$410,000', daysOnMarket: '29 days' },
      { suburb: 'Mill Park', medianHouse: '$720,000', medianUnit: '$430,000', daysOnMarket: '27 days' },
      { suburb: 'Thomastown', medianHouse: '$690,000', medianUnit: '$420,000', daysOnMarket: '30 days' },
      { suburb: 'Wollert', medianHouse: '$650,000', medianUnit: '$400,000', daysOnMarket: '24 days' },
      { suburb: 'Mernda', medianHouse: '$670,000', medianUnit: '$410,000', daysOnMarket: '23 days' },
      { suburb: 'Doreen', medianHouse: '$710,000', medianUnit: '$430,000', daysOnMarket: '25 days' },
      { suburb: 'Bundoora', medianHouse: '$820,000', medianUnit: '$480,000', daysOnMarket: '26 days' },
      { suburb: 'Reservoir', medianHouse: '$850,000', medianUnit: '$500,000', daysOnMarket: '25 days' },
    ]}
  />
);

export default EppingPage;
